import Urls from '../urls.js';
import { debounce } from '../../../../scripts/utils/debounce.js';
import BaseView from '../../../../scripts/utils/base-view.js';

export default class AddToCartStickyFooterView extends BaseView {
	constructor({
		cart_product,
		allow_duplicates,
		el,
		add_to_cart_el,
		is_accessory
	}) {
		super(el);
		this.template_url = Urls.Templates.sticky_footer;
		this.parent_element = document.querySelector(el);
		this.add_to_cart_element = document.querySelector(add_to_cart_el);
		this.allow_duplicates = allow_duplicates;
		this.in_cart = cart_product && !allow_duplicates;
		this.is_accessory = is_accessory;

		this.footer_element = null;
		this.btn_add_to_cart = null;

		this.debouncingFooterVisibility = debounce(() => this.handleFooterVisibility(), 100);

		if (this.add_to_cart_element && !this.is_accessory) {
			this.render();
			this.bindCartEvents();
		}
	}

	get_context () {
		return {
			in_cart: this.in_cart,
			path: window.location.pathname
		};
	}

	after_render () {
		this.initSelectors();
	}

	initSelectors() {
		this.removeListeners();
		this.footer_element = document.querySelector('.cart-sticky-footer');
		this.btn_add_to_cart = this.footer_element.querySelector('button[name="addtocart"]');
		this.addListeners();
	}

	addListeners() {
		this.addScrollResizeHandler();

		if (this.btn_add_to_cart) {
			this.btn_add_to_cart.addEventListener('click', this.addToCart.bind(this));
		}
	}

	removeListeners() {
		this.removeScrollResizeHandler();

		if (this.btn_add_to_cart) {
			this.btn_add_to_cart.removeEventListener('click', this.addToCart.bind(this));
		}
	}

	addToCart() {
		this.btn_add_to_cart.setAttribute('disabled', true);
		this.btn_add_to_cart.classList.add('progress');
		const add_product_event = new CustomEvent('[add-to-cart]:add-product');
		document.dispatchEvent(add_product_event);
	}

	bindCartEvents() {
		document.addEventListener('[add-to-cart]:product-added', () => {
			if (!this.allow_duplicates) {
				this.in_cart = true;
			}
			this.render();
		});
	}

	addScrollResizeHandler() {
		['scroll', 'resize'].forEach(event_name => {
			window.addEventListener(event_name, this.debouncingFooterVisibility);
		});
	}

	removeScrollResizeHandler() {
		['scroll', 'resize'].forEach(event_name => {
			window.removeEventListener(event_name, this.debouncingFooterVisibility);
		});
	}

	handleFooterVisibility() {
		if (this.add_to_cart_element.getBoundingClientRect().top + window.pageYOffset + this.add_to_cart_element.clientHeight < window.pageYOffset) {
			if (this.footer_element.classList.contains('hide')) {
				this.footer_element.classList.remove('hide');
			}
			this.footer_element.classList.add('fixed-bottom');
			this.footer_element.classList.remove('slide-down');

			if ((document.body.scrollHeight - window.innerHeight) === window.pageYOffset) {
				this.footer_element.classList.add('slide-down');
			}
		} else {
			this.footer_element.classList.add('slide-down');
			this.footer_element.classList.remove('fixed-bottom');
		}
	}
}